import React from 'react';
import {
  FormGroup,
  Button,
  Row,
  Col,
} from 'reactstrap';

const styles = {
  row: {
    flexDirection: 'row-reverse',
  },
  col: {
    textAlign: 'right',
  },
};

export default function FooterFormGroup(props) {
  const { buttonLabel, onSubmit } = props;

  return (
    <FormGroup>
      <Row style={styles.row}>
        <Col sm="4" style={styles.col}>
          <Button color="success" onClick={onSubmit}>
            {buttonLabel}
          </Button>
        </Col>
      </Row>
    </FormGroup>
  );
}
